import { render, staticRenderFns } from "./SkeletonTransactionHistoryComponent.vue?vue&type=template&id=7373df58&scoped=true&"
import script from "./SkeletonTransactionHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonTransactionHistoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonTransactionHistoryComponent.vue?vue&type=style&index=0&id=7373df58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7373df58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
